import request from '@/modules/base/util/request'

import {
  settingsError,
  settingsLoading,
  settingsLoadingFinished,
  toggleSettingModal,
} from '@/redux/ducks/lists'

export const typedUpdateColumnSetting = (data, updateFromSettingModal, LIST_TYPE, url, fetchListSetting) => {
  return (dispatch) => {
    const sendRequest = request(`${url}/columns`, {
      auth: true,
      method: 'PUT',
      data: data.filter(item => item.label && item.name),
    })

    updateFromSettingModal && dispatch(settingsLoading(LIST_TYPE))

    sendRequest
      .then((response) => {
        dispatch(settingsLoadingFinished(LIST_TYPE))
        if (updateFromSettingModal) {
          dispatch(toggleSettingModal(LIST_TYPE, false))
          dispatch(fetchListSetting(LIST_TYPE))
        }
      })
      .catch((error) => {
        dispatch(settingsError(LIST_TYPE, error))
      })
  }
}
